import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import editIcon from "../../../assets/img/small-logos/edit_icon.svg"
import deleteIcon from "../../../assets/img/small-logos/delete _icon.svg";
import Swal from "sweetalert2";
import { Button, Col, Row, Form } from "react-bootstrap";
import { Formik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import "../doorstepServices/DoorstepServices.css"
import { IRequirementValues, ISubCategory } from "src/helper/interfaces";
import FilterButton from "src/components/layout/FilterButton";
import Cookies from "js-cookie";
import placeHolderImg from "../../../assets/img/landscape-placeholder-svgrepo-com.svg"
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import Paginator from "src/components/layout/Paginator";
import LoadingGif from "src/components/layout/Loader";
interface InitialValuesType {
   name: string;
   type: string;
   icon: string | null;
   description?: string;

}

const getAllRequirementValues = async (token: string, pageNumber: number, pageSize: number, searchValue: string, requirementType: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/requirement-value`, {
      headers: {
         "x-access-token": token
      },
      params: {
         service_type: "normal_worker",
         page: pageNumber,
         requirement_type: requirementType,
         search_value: searchValue,
         pageSize
      }

   })
};

const getAllSubCategories = async (token: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/sub-categories`, {
      headers: {
         "x-access-token": token
      },
      params: {
         pageSize: 100
      }
   })

};


const RequirementValues = () => {
   const [subCats, setSubCats] = useState<ISubCategory[]>([]);
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state?.loading?.value);
   const [editMode, setEditMode] = useState(false);
   const [modalShow, setModalShow] = useState(false);
   const selectedOption = useAppSelector((state) => state?.requirementAnsSupport?.requirementType?.value);
   const Token = Cookies.get('token');
   const [searchVal, setSearchVal] = useState('');
   const [requirementValues, setRequirementValues] = useState<any[]>([])
   const [pageNo, setPageNo] = useState(1);
   const [pageSize, setPageSize] = useState(20);
   const [totalPages, setTotalPages] = useState(0);
   const requirementType = useAppSelector(state => state?.requirementAnsSupport?.requirementType?.value);
   useEffect(() => {
      setPageNo(1)
   }, [selectedOption]);

   const fetchRequirementValues = (Token: string, pageNo: number, pageSize: number, searchVal: string, requirementType: string) => {
      dispatch(startLoading());

      getAllRequirementValues(Token, pageNo, pageSize, searchVal, requirementType)
         .then((res) => {
            if (res?.data?.status_code === 200) {
               setRequirementValues(res?.data?.data?.data);
               setTotalPages(res?.data?.data?.totalPages);
            } else {
               Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: `${res?.data?.data?.msg}`,
               });
            }
         })
         .catch((error) => {
            console.error("Error fetching data:", error);
         })
         .finally(() => {
            dispatch(stopLoading());
         });
   };

   useEffect(() => {

      fetchRequirementValues(Token as string, pageNo, pageSize, searchVal, requirementType);
   }, [Token, pageNo, searchVal, requirementType])

   const [selectedRequirement, setSelectedRequirement] = useState<IRequirementValues | null>(null);
   const initialValues: InitialValuesType = {
      name: "",
      type: "",
      icon: "",
      description: "",
   };

   const [inputs, setInputs] = useState(initialValues);

   const validationSchema = yup.object().shape({

      name: yup.string()
         .required('Please Fill this field (Name).'),
      // type: yup.string().oneOf(["work", "job"], "Type must be either work or job.").required("Please Fill this Field (Type)."),
      icon: yup.mixed().required('Please upload a file'),
   });

   useEffect(() => {
      if (Token) {
         getAllSubCategories(Token).then((res) => {
            // console.log(res?.data?.data?.data);
            if (res?.data?.status_code === 200) {
               // console.log(res?.data?.data)
               setSubCats(res?.data?.data?.data)
            }
         })
            .catch((err: any) => {
               console.log(err)
            })
      }
   }, [selectedOption]);

   const onCreate = () => {
      setEditMode(false);
      setModalShow(true);
      setInputs({
         name: "",
         type: "",
         icon: null,
         description: "",

      })
   }

   const onHide = () => {
      setModalShow(false);
      setEditMode(false);
      // setInputs(initialValues);
   }

   const onUpdate = (id: string) => {
      const valuesToEdit = requirementValues.find((value: IRequirementValues) => value._id === id);
      setSelectedRequirement(valuesToEdit);

      // Populate the form fields with the existing data
      setInputs({
         ...inputs,
         name: valuesToEdit?.name || "",
         icon: valuesToEdit?.icon ? valuesToEdit?.icon : null,
         type: selectedOption,
         description: valuesToEdit?.description || ""
      });

      setEditMode(true);
      setModalShow(true);
   };

   const handleDeleteConfirmed = (id: string) => {
      // console.log(id);
      if (Token === undefined) {
         console.error("Token is undefined");
         return;
      }
      // Dispatch the delete action here
      Swal.fire({
         title: 'Are you sure?',
         text: "You won't be able to revert this!",
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'Yes, delete it!'
      }).then(async (response) => {
         if (response.isConfirmed) {

            await axios({
               url: `${AppConfig.DEV_SERVER}/requirement-value/${id}`,
               method: "DELETE",
               headers: {
                  'content-type': 'multipart/form-data',
                  "x-access-token": Token,
               }
            }).then((res) => {
               // console.log(res)
               Swal.fire(
                  'Deleted!',
                  `${res?.data?.msg}`,
                  'success'
               ).then(() => {
                  dispatch(stopLoading());
                  fetchRequirementValues(Token as string, pageNo, pageSize, searchVal, requirementType);
               })

            }).catch((err) => {
               console.log(err)
            })  // Clear the selectedFoodItem state after updating
            setModalShow(false);
         }
      }
      )
   };


   const handleFormSubmit = async (formInput: any, resetForm: () => void) => {
      const formData = new FormData();

      // console.log(formInput);
      formData.append('name', formInput.name);
      formData.append('type', selectedOption?.toLocaleLowerCase());
      formData.append('description', formInput.description);

      if (formInput.icon != "" && formInput.icon != undefined) {
         formData.append('icon', formInput.icon);
      }

      // console.log(formInput);
      if (!Token) return;
      dispatch(startLoading());
      if (!editMode) {
         // Add new food item

         await axios({
            url: `${AppConfig.DEV_SERVER}/requirement-value`,
            method: "POST",
            data: formData,
            headers: {
               'content-type': 'multipart/form-data',
               "x-access-token": Token,
            }
         }).then(async (res) => {

            // console.log(res?.data)
            if (res?.data?.status_code !== 200) {
               setModalShow(false);
               // dispatch(stopLoading());
               Swal.fire({
                  position: "center",
                  icon: "error",
                  title: `${res?.data?.msg}`,
                  showConfirmButton: false,
                  timer: 5500
               }).then(() => {
                  resetForm();
                  dispatch(stopLoading());
               })
            }
            else {
               if (res?.data?.status_code === 200) {
                  setModalShow(false);
                  Swal.fire({
                     position: "center",
                     icon: "success",
                     title: `Added new Requirement Value, ${formInput.name}.`,
                     showConfirmButton: false,
                     timer: 1500
                  }).then(() => {
                     resetForm();
                     dispatch(stopLoading());
                     fetchRequirementValues(Token as string, pageNo, pageSize, searchVal, requirementType);

                  })
               }
            }
         })
      } else {
         if (selectedRequirement != null) {
            if (selectedRequirement?._id) {

               // console.log(selectedRequirement);
               await axios({
                  url: `${AppConfig.DEV_SERVER}/requirement-value/${selectedRequirement?._id}`,
                  method: "PUT",
                  headers: {
                     'content-type': 'multipart/form-data',
                     "x-access-token": Token,
                  },
                  data: formData,
               }).then(async (res) => {

                  // console.log(res?.data)
                  if (res?.data?.status_code !== 200) {
                     setModalShow(false);
                     Swal.fire({
                        position: "center",
                        icon: "error",
                        title: `${res?.data?.msg}`,
                        showConfirmButton: false,
                        timer: 2000
                     }).then(() => {
                        resetForm();
                        dispatch(stopLoading());
                     })
                  }
                  else {
                     if (res?.data?.status_code === 200) {

                        setModalShow(false);
                        Swal.fire({
                           position: "center",
                           icon: "success",
                           title: `Requirement Value Updated, ${formInput.name}.`,
                           showConfirmButton: false,
                           timer: 1500
                        }).then(() => {
                           resetForm();
                           dispatch(stopLoading());
                           fetchRequirementValues(Token as string, pageNo, pageSize, searchVal, requirementType);
                        })
                     }
                  }
               })

            }
         } else {
            console.error("Selected food item or its ID is undefined.");
         }
      }
   }
   //  this below code is for Category name 
   const handleDropdownChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
      // setSelectedValue(event.target.value);
      setSelectedRequirement({ ...selectedRequirement as IRequirementValues, name: event?.target?.value });

      // console.log(event.target.value)
   }
   const clearSearchValue = () => {
      setSearchVal("");  // Clear the search input
   };
   return (
      <MainLayout searchValue={searchVal} onChange={(e) => setSearchVal(e.target.value)} clearValChange={clearSearchValue}>

         <div className="mt-3 mb-3">
            <Formik
               validationSchema={validationSchema}
               onSubmit={(values, { resetForm }) => {
                  handleFormSubmit(values, resetForm)
               }}
               enableReinitialize={true}
               validateOnChange={false}
               validateOnBlur={false}
               initialValues={inputs}
            >
               {({ handleSubmit, handleChange, setFieldValue, values, touched, errors }) => (
                  <Modal show={modalShow} onHide={() => onHide()} size="lg" className="rounded-9 category-modal">
                     <Form noValidate onSubmit={handleSubmit}>
                        <Modal.Header closeButton>
                           <Modal.Title as="h5">{editMode ? 'Update Value' : 'Add Value'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                           <Row className="fieldset-row" >
                              <Col md={12} className="mb-2">
                                 <Form.Control name="icon" type="file" required onChange={(event: any) => {
                                    const file = event.currentTarget.files[0];
                                    // console.log(file);
                                    setFieldValue("icon", file);
                                 }} isValid={touched.icon && !errors.icon} isInvalid={!!errors.icon} />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.icon}
                                 </Form.Control.Feedback>
                              </Col>
                              {
                                 selectedOption === "Job" ?
                                    <Col md={12} className="mb-b">
                                       <Form.Label htmlFor="name">Value Name</Form.Label>
                                       <Form.Select
                                          name="name"
                                          value={values.name}  // Tie this to Formik's state for consistency
                                          onChange={(event) => {
                                             const { value } = event.target;
                                             setFieldValue('name', value);  // Update Formik's state for 'name'
                                             handleDropdownChange(event);   // Call your custom handler if necessary
                                          }}
                                          isValid={touched.name && !errors.name}
                                          isInvalid={!!errors.name}
                                       >
                                          <option value="" >Select Job Value</option>
                                          {subCats && subCats.map((value, index) => (
                                             <option key={index} value={value.sub_category_name}>
                                                {value.sub_category_name}
                                             </option>
                                          ))}
                                       </Form.Select>
                                       <Form.Control.Feedback type="invalid">
                                          {errors.name}
                                       </Form.Control.Feedback>

                                    </Col>
                                    :
                                    <Col md={12} className="mb-2">
                                 <Form.Label htmlFor="name">Value Name</Form.Label>

                                 <Form.Control id="name" type='text' onChange={handleChange} isValid={touched.name && !errors.name} value={values.name} isInvalid={!!errors.name} />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.name}
                                 </Form.Control.Feedback>
                              </Col>
                              }

                              <Col md={12} className="mb-2">
                                 <Form.Label htmlFor="type">Type</Form.Label>
                                 <Form.Control id="type" type='text' readOnly value={selectedOption} />

                              </Col>

                              <Col md={12} className="mb-2">
                                 <Form.Label htmlFor="description">Description</Form.Label>
                                 <Form.Control id="description" type='text' onChange={handleChange} isValid={touched.description && !errors.description} value={values.description} isInvalid={!!errors.description} />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.description}
                                 </Form.Control.Feedback>
                              </Col>

                           </Row>
                        </Modal.Body>
                        <Modal.Footer>
                           <Button variant="app-warning" type="submit" className="ps-4 pe-4 add-cat-btn" >
                              {editMode ? 'Update Value' : 'Add Value'}
                           </Button>
                        </Modal.Footer>
                     </Form>
                  </Modal>
               )
               }
            </Formik >
            <div className="card category-main me-2 p-3 p-md-4">
               {
                  loading ?
                     <div>
                        <LoadingGif />
                     </div>
                     : ""
               }
               <div>
                  <div className="d-flex justify-content-end mb-3">

                     <div className="d-flex justify-content-end gap-4 w-md-100 w-xxl-50 ">


                        <FilterButton
                           name={selectedOption}
                           type="requirement"
                           options={["Work", "material", "Job"]}

                        />
                        <span className="add-cat" onClick={() => onCreate()}>
                           <button className="add-cat-btn">Add Values</button>
                        </span>
                        {/* <SearchBar width="50%" value={searchValue} onInputChange={(e) => setSearchValue(e?.target?.value)} /> */}
                     </div>

                  </div>
                  <div className="table-extra-responsive">
                  <table className="table table-hover card-body">
                     <thead>
                        <tr className="category-tr">
                           {/* <th scope="col" className="text-start ps-4">name</th> */}
                              <th scope="col" className="text-start ps-4">Sr.No.</th>
                              <th scope="col" className="text-start ps-4">Value Id</th>
                           <th scope="col" className="text-start ps-4">Value Type </th>
                           <th scope="col" className="text-start ps-4">Name </th>
                           <th scope="col" className="text-start ps-4">Icon </th>
                           <th scope="col" className="text-start ps-4">Description </th>

                           <th scope="col" className="cat_btns">Action</th>
                        </tr>
                     </thead>
                     <tbody>
                        {
                              requirementValues && requirementValues?.map((data: IRequirementValues, i) => {

                              // const res = Providers?.join(", ")
                                 const rowNumber = (pageNo - 1) * pageSize + (i + 1);
                              return (
                                 <tr key={data?._id}>

                                    <td className="text-start ps-4 pt-3">{rowNumber}</td>
                                    <td className="text-start ps-4 pt-3">{data?._id}</td>
                                    <td className="text-start ps-4 pt-3">{data?.type}</td>
                                    <td className="text-start ps-4 pt-3">{data?.name}</td>
                                    {/* <td className="text-start ps-4 pt-3">{data?._id}</td> */}

                                    <td className="text-start align-content-center">
                                       {data?.icon ?
                                          <img src={data?.icon} alt="profile-pic" className="profile-pic" />
                                          :
                                          <span className="d-flex align-items-center ">
                                             <img src={placeHolderImg} alt="profileIcon" className="profile-pic" />
                                          </span>}
                                    </td>
                                    <td className="text-start ps-4 pt-3">{data?.description?.length !== 0 ? data?.description : "NA"}</td>



                                    <td className="align-content-center ">
                                       <div className="d-flex justify-content-center gap-3">
                                          <button className="btn btn-sm edit_btn" onClick={() => onUpdate(data?._id)}>
                                             <img src={editIcon} />
                                          </button>
                                          {/* <button className="btn btn-sm delete_btn " onClick={() => clickOnShow(data?._id)}>
                                             <img src={eye} />
                                          </button> */}
                                          <button className="btn btn-sm delete_btn " onClick={() => handleDeleteConfirmed(data?._id)}>
                                             <img src={deleteIcon} />
                                          </button>
                                       </div>

                                    </td>
                                 </tr>
                              )
                           }
                           )
                        }


                     </tbody>
                  </table>
                  </div>


                  <Paginator
                     totalPages={totalPages}
                     pageNo={pageNo}
                     onPageChange={(e, no) => setPageNo(no)}
                     alignment="right"
                  />
               </div>


            </div>

         </div>

      </MainLayout>
   )

};



export default RequirementValues;